export default function () {
    const productHovers = Array.from(document.querySelectorAll("[data-hover-src]"));
    productHovers.forEach((p) => {
        p.addEventListener("mouseover", (e) => {
            var src = e.target.src;
            e.target.src = e.target.dataset.hoverSrc;
            e.target.dataset.hoverSrc = src;
        });
        p.addEventListener("mouseout", (e) => {
            var src = e.target.src;
            e.target.src = e.target.dataset.hoverSrc;
            e.target.dataset.hoverSrc = src;
        });
    });

    const productClicks = Array.from(document.querySelectorAll("[data-product-click]"));
    productClicks.forEach((p) => {
        p.addEventListener("click", (e) => {
            var productObj = JSON.parse(p.dataset.productClick);
            // Push to datalayer
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                'event': 'select_item',
                'ecommerce': {
                    'currency': 'EUR',
                    'items': [{
                        'item_name': productObj.name, // Name or ID is required.
                        'item_id': productObj.id,
                        'item_brand': productObj.brand,
                        'item_category': productObj.category,
                        'price': productObj.price,
                        'index': 1
                    }]
                }
            });
        });
    });
}
